import React, { useState, useEffect } from "react";
import "./Home.css";
import BannerForm from "./BannerForm";
import WhyChooseUs from "./WhyChooseUs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faFilePdf } from "@fortawesome/free-brands-svg-icons"; // for WhatsApp
import { faFilePdf as faFilePdfSolid } from "@fortawesome/free-solid-svg-icons"; // for PDF
import Modal from "react-modal"; // Import the Modal component
import QueryForm from "./QueryForm";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isZooming, setIsZooming] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [currentSlideGift, setCurrentSlideGift] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const productImages = [
    "https://trumachealthcare.net/app_admin/assets/images/products/bilastic-m.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/acomust-100.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/dydrowise-10.jpeg",
    "https://trumachealthcare.net/camrut_app_admin/assets/images/products/sitawise-dm-100-10-500.jpeg",
    "https://trumachealthcare.net/camrut_app_admin/assets/images/products/dapacam-mv-500.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/pregacam-d-75-20.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/zacobal-forte-tab.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/cobavent-czs.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/heparut_sachets.jpg",
    "https://trumachealthcare.net/camrut_app_admin/assets/images/products/ticaron-90.jpeg",
    "https://trumachealthcare.net/camrut_app_admin/assets/images/products/dapacam-10-14.jpeg",
    "https://trumachealthcare.net/camrut_app_admin/assets/images/products/sacuvon-50.jpeg",
    "https://trumachealthcare.net/app_admin/assets/images/products/apixer-5.jpeg",
  ];

  const giftImages = [
    "https://trumachealthcare.net/apiwha/1200-ml-bottle.jpeg",
    "https://trumachealthcare.net/apiwha/milton-combo.jpg",
    "https://trumachealthcare.net/apiwha/bean-bag.jpg",
    "https://trumachealthcare.net/apiwha/borosil-lunch-box.jpg",
    "https://trumachealthcare.net/apiwha/milton-caserol.jpg",
    "https://trumachealthcare.net/apiwha/montavo-cutlery-set.jpg",
    "https://trumachealthcare.net/apiwha/honor-pad.jpg",
    "https://trumachealthcare.net/apiwha/borosil-coffee-mug-10000.jpg",
    "https://trumachealthcare.net/apiwha/havells-hair-dryer.jpg",
    "https://www.trumachealthcare.net/apiwha/samsung-m04.jpg",
    "https://trumachealthcare.net/apiwha/parker-combo.jpeg",
    "https://trumachealthcare.net/apiwha/prestige-anodised-cooker.jpg",
    "https://trumachealthcare.net/apiwha/personalised-diary-set.jpg",
  ];

  useEffect(() => {
    if (!sessionStorage.getItem("modalClosed")) {
      const timer = setTimeout(() => {
        setIsModalOpen(true);
      }, 10000); // 10 seconds

      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    sessionStorage.setItem("modalClosed", "true");
  };

  // Handle the change of slides
  const handleSlideChange = (direction) => {
    setCurrentSlide((prevSlide) => {
      const newSlide =
        (prevSlide + direction + productImages.length) % productImages.length;
      return newSlide;
    });
  };

  // Get the visible images
  const getVisibleImages = () => {
    const visibleImages = [];
    for (let i = 0; i < 4; i++) {
      visibleImages.push(
        productImages[(currentSlide + i) % productImages.length]
      );
    }
    return visibleImages;
  };

  // Auto-slide every 3 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      handleSlideChange(1);
    }, 3000); // Slide every 3 seconds

    return () => clearInterval(intervalId); // Clean up the interval on component unmount
  }, []);

  const handleSlideChangeGift = (direction) => {
    setCurrentSlideGift((prevSlide) => {
      const newSlide =
        (prevSlide + direction + giftImages.length) % giftImages.length;
      return newSlide;
    });
  };

  // Get the visible images
  const getVisibleImagesGift = () => {
    const visibleImages = [];
    for (let i = 0; i < 4; i++) {
      visibleImages.push(
        giftImages[(currentSlideGift + i) % giftImages.length]
      );
    }
    return visibleImages;
  };

  // Auto-slide every 3 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      handleSlideChangeGift(1);
    }, 3000); // Slide every 3 seconds

    return () => clearInterval(intervalId); // Clean up the interval on component unmount
  }, []);

  const handleZoom = (image) => {
    setIsZooming(true);
    setZoomedImage(image);
  };

  const handleCloseZoom = () => {
    setIsZooming(false);
    setZoomedImage(null);
  };

  // Open and close modal
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="landing-page">
      <BannerForm />

      {/* Product Slider Section */}
      <section className="product-slider">
        <h2 class="latest-products-heading">Our Latest Products</h2>
        <div className="slider">
          <button className="prev-btn" onClick={() => handleSlideChange(-1)}>
            &lsaquo;
          </button>
          <div className="slider-wrapper">
            {getVisibleImages().map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Product ${currentSlide + index + 1}`}
                className="product-image"
                onClick={() => handleZoom(image)}
              />
            ))}
          </div>
          <button className="next-btn" onClick={() => handleSlideChange(1)}>
            &rsaquo;
          </button>
        </div>
        {isZooming && (
          <div className="zoom-overlay-home" onClick={handleCloseZoom}>
            <img
              src={zoomedImage}
              alt="Zoomed Product"
              className="zoomed-image"
            />
          </div>
        )}
        <a
          href="https://trumachealthcare.net/pharmaflow/"
          className="view-more-btn"
        >
          View More Products
        </a>
      </section>

      <WhyChooseUs />

      {/* Product Slider Section */}
      <section className="product-slider">
        <h2 class="latest-products-heading">Promotional Gifts</h2>
        <div className="slider">
          <button
            className="prev-btn"
            onClick={() => handleSlideChangeGift(-1)}
          >
            &lsaquo;
          </button>
          <div className="slider-wrapper">
            {getVisibleImagesGift().map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Product ${currentSlide + index + 1}`}
                className="product-image"
                onClick={() => handleZoom(image)}
              />
            ))}
          </div>
          <button className="next-btn" onClick={() => handleSlideChangeGift(1)}>
            &rsaquo;
          </button>
        </div>
        {isZooming && (
          <div className="zoom-overlay-home" onClick={handleCloseZoom}>
            <img
              src={zoomedImage}
              alt="Zoomed Product"
              className="zoomed-image"
            />
          </div>
        )}
        <a
          href="https://trumachealthcare.net/pharmaflow/#/gifts"
          className="view-more-btn"
        >
          View More Gifts
        </a>
      </section>

      {/* Footer Section */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-column">
            <h4>About Trumac Healthcare</h4>
            <p>
              Trumac Healthcare is a leading pharmaceutical company specializing
              in quality healthcare products. Our commitment is to provide
              innovative and affordable solutions.
            </p>
          </div>

          <div className="footer-column">
            <h4>Contact Us</h4>
            <p>Email: trumachealthcare@gmail.com</p>
            <p>Phone: +91 8725092149</p>
            <a
              href="https://wa.me/918725092149/?text=Hello,%20I%20want%20to%20take%20franchise%20of%20your%20company.%20My%20Working%20Area%20is" // Link to WhatsApp
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              WhatsApp Enquiry
            </a>
            <a
              href="tel:+918725092149" // Link to initiate a phone call
              className="call-btn"
            >
              Call Us
            </a>
          </div>
        </div>

        {/* <div className="footer-bottom">
          <p>© 2024 Trumac Healthcare. All Rights Reserved.</p>
        </div> */}
      </footer>
      {/* Sticky Icons */}
      <a
        href="tel:+918725092149"
        className="sticky-icon call-icon"
        aria-label="Call Us"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faPhoneAlt} />
      </a>
      <a
        href="https://wa.me/918725092149/?text=Hello,%20I%20want%20to%20take%20franchise%20of%20your%20company.%20My%20Working%20Area%20is"
        className="sticky-icon whatsapp-icon"
        aria-label="WhatsApp Us"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
      <a
        href="http://bit.ly/trumac_pl"
        className="sticky-icon pdf-icon"
        aria-label="Download PDF"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faFilePdfSolid} />
      </a>

      {/* Sticky Button */}
      <button className="sticky-button" onClick={openModal}>
        Submit Query
      </button>

      {/* Modal for Query Form */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Query Form"
        className="modal"
        overlayClassName="overlay"
      >
        <QueryForm onClose={handleCloseModal} />
      </Modal>
    </div>
  );
};

export default Home;
